(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pairs-well-with"] && !Shopify.designMode) return;
  try {
    (() => {
    const initPairsWellWith = (root) => {
      const viewport = root.querySelector('[data-carousel-viewport]');
      const previousButton = root.querySelector('[data-carousel-prev]');
      const nextButton = root.querySelector('[data-carousel-next]');

      if (!viewport || !previousButton || !nextButton) return;

      const updateButtons = () => {
        const maxScroll = viewport.scrollWidth - viewport.clientWidth;
        const currentScroll = viewport.scrollLeft;

        previousButton.disabled = currentScroll <= 1;
        nextButton.disabled = currentScroll >= maxScroll - 1;
      };

      previousButton.addEventListener('click', () => {
        viewport.scrollBy({
          left: -viewport.clientWidth,
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        viewport.scrollBy({
          left: viewport.clientWidth,
          behavior: 'smooth'
        });
      });

      viewport.addEventListener('scroll', updateButtons, {
        passive: true
      });

      window.addEventListener('resize', updateButtons);

      updateButtons();
    };

    const init = () => {
      document
        .querySelectorAll('[data-pairs-carousel]')
        .forEach((root) => {
          if (root.dataset.pairsInitialized) return;

          root.dataset.pairsInitialized = 'true';
          initPairsWellWith(root);
        });
    };

    init();

    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
